import { colors, borderRadius, typography } from "../../../styles/theme.js";

const styles = {
  container: {
    padding: 40,
    textAlign: "center",
    color: colors.textSecondary,
    fontSize: typography.fontSize.md,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  icon: {
    fontSize: 48,
    marginBottom: 12,
  },
  message: {
    fontSize: typography.fontSize.md,
    color: colors.textSecondary,
  },
};

export const EmptyState = ({ icon, message, subMessage }) => {
  return (
    <div
      style={{
        ...styles.container,
      }}
    >
      {icon && <div style={{ fontSize: 48, marginBottom: 12 }}>{icon}</div>}
      <div>{message}</div>
      {subMessage && (
        <div
          style={{
            fontSize: typography.fontSize.sm,
            marginTop: 8,
            color: colors.textTertiary,
          }}
        >
          {subMessage}
        </div>
      )}
    </div>
  );
};
